module.exports = __webpack_public_path__ + "img/arrow-up-right.cc127e46.svg";